import { jsx as _jsx } from "react/jsx-runtime";
const SvgComponent = ({ fill = '#68597A', ...props }) => (_jsx("svg", { xmlns: "http://www.w3.org/2000/svg", width: 21, height: 21, fill: "none", ...props, children: _jsx("path", { strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round", stroke: fill, d: "M13.3672 15.667L8.36719 10.667L13.3672 5.66699" }) }));
export default SvgComponent;
